import {
  GROUPING_CATEGORY_AREA,
  GROUPING_CATEGORY_EQUIPMENT,
  GROUPING_FILTER_AREA_FUNCTIONAL,
  GROUPING_FILTER_EQUIPMENT_TYPE,
  GROUPING_FILTER_TYPE,
  GROUPING_MODE_GROUP,
  GROUPING_MODE_OFF,
  GROUPING_MODE_SUM,
  SET_GROUPING_CATEGORY,
  SET_GROUPING_FILTER,
  SET_GROUPING_FILTER_RELATIONS,
  SET_GROUPING_MODE
} from '../constants/actionTypes';

const initialStateFilter = {
  mode: GROUPING_MODE_OFF,
  category: null,
  filter: null
};

const groupFilter = (state = initialStateFilter, action) => {
  switch (action.type) {
    case SET_GROUPING_MODE:
      if (action.mode === GROUPING_MODE_OFF) {
        return initialStateFilter;
      }

      if (action.mode === GROUPING_MODE_GROUP) {
        return {
          mode: action.mode,
          category: GROUPING_CATEGORY_EQUIPMENT,
          filter: GROUPING_FILTER_EQUIPMENT_TYPE
        };
      }

      if (action.mode === GROUPING_MODE_SUM) {
        return {
          mode: action.mode,
          category: GROUPING_CATEGORY_EQUIPMENT,
          filter: GROUPING_FILTER_EQUIPMENT_TYPE
        };
      }

      return {
        ...state,
        mode: action.mode
      };

    case SET_GROUPING_CATEGORY:
      if (action.category === GROUPING_CATEGORY_AREA) {
        return {
          ...state,
          category: action.category,
          filter: GROUPING_FILTER_AREA_FUNCTIONAL
        };
      }
      if (action.category === GROUPING_CATEGORY_EQUIPMENT) {
        return {
          ...state,
          category: action.category,
          filter: GROUPING_FILTER_AREA_FUNCTIONAL
        };
      }
      return {
        // GROUPING_CATEGORY_TYPE
        ...state,
        category: action.category,
        filter: GROUPING_FILTER_TYPE
      };

    case SET_GROUPING_FILTER:
      return {
        ...state,
        filter: action.filter
      };

    default:
      return state;
  }
};

export default groupFilter;

const initialState = {
  area_room: null,
  area_functional: null,
  building_floor: null,
  equipment_type: null,
  equipment_group: null,
  type: null,
  updated: false
};

export const groupFilterRelations = (state = initialState, action) => {
  switch (action.type) {
    case SET_GROUPING_FILTER_RELATIONS:
      return { ...action.payload, updated: true };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/grouping.js